import React from 'react';
import {
    Div,
    SplitCol,
    SplitLayout,
    Button,
    Search, ModalPageHeader, PanelHeaderButton, ModalPage, ModalRoot
} from '@vkontakte/vkui';

import {
    Icon24BrowserBack,

    Icon24Info
} from "@vkontakte/icons";
import {AdaptivityContext, setQuizStep} from "../assets/constants";
import * as constants from "../assets/constants";
import IncomingDocsViewer from "./IncomingDocsViewer";
import BaseComponent from "../components/BaseComponent";


class IncomingStepHeader extends BaseComponent {

    state = {
        mainSearch: '',

    }

    constructor(props) {
        super(props);

    }

    receiveMessage = (event) => {
        if (event.data == 'stepPrev') {
            if (this.state.activeModal == null) {
                if(this.props.step > 1) {
                    setQuizStep(this.props.step - 1, 'Incoming')
                } else {
                    window.postMessage('goToMain')
                }
            } else {
                this.modalBack()
            }
        }
    }

    scrollPrev = 0
    checkToolbarScroll = () => {
        let headerMobStorage = document.getElementsByClassName('mobile-table-storage-header')

        if (!headerMobStorage || headerMobStorage.length === 0) return

        headerMobStorage = headerMobStorage[0]
        const scrolled = window.scrollY

        if (scrolled > 100 && scrolled > this.scrollPrev) {
            headerMobStorage.classList.add('out')
        } else {
            headerMobStorage.classList.remove('out')
        }
        this.scrollPrev = scrolled
    }


    handleScroll() {
        this.checkToolbarScroll()
    }

    onSearchChange = (e) => {
        this.setState({mainSearch: e.target.value})
        this.props.onSearchChange(e)
    }

    render() {
        const modals = (
            <ModalRoot activeModal={this.state.activeModal}>
                <ModalPage
                    id={constants.MODAL_INCOMINGS_INFO}
                    onClose={this.modalBack}
                    settlingHeight={100}
                    style={{zIndex: '999999'}}
                    header={
                        <ModalPageHeader className="sclads"
                                         before={<PanelHeaderButton
                                             onClick={this.modalBack}><Icon24BrowserBack/></PanelHeaderButton>}

                        >
                            Документы приемки
                        </ModalPageHeader>
                    }
                >
                    <IncomingDocsViewer items={this.props.currentDocs}/>
                </ModalPage>
            </ModalRoot>
        );

        return (<Div
            className={AdaptivityContext.isMobile ? 'mobile-table-storage-header' : 'desktop-table-storage-header'}>
            <SplitLayout modal={modals} style={{height: AdaptivityContext.isMobile&&this.state.activeModal?AdaptivityContext.h+'px':'inherit'}}
            >
                <SplitCol width={"10%"} style={{justifyContent: 'start'}}>
                    <Button before={<Icon24Info/>}
                            onClick={() => this.setActiveModal(constants.MODAL_INCOMINGS_INFO)}
                            mode="secondary" size="l">
                        {!this.props.onSearchChange && 'Подробнее'}
                    </Button>
                </SplitCol>
                {this.props.onSearchChange && <SplitCol width={"80%"}>
                    <Search theme="header"
                            placeholder="Поиск"
                            value={this.state.mainSearch}
                            onChange={this.onSearchChange}

                            style={{flexGrow: '1', maxWidth: '350px'}}
                    />
                </SplitCol>}
            </SplitLayout>
        </Div>)
    }
}


export default IncomingStepHeader